import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, MagnifyingGlass } from "@phosphor-icons/react";

export default function AuditBar() {
  const [url, setUrl] = useState("");
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const v = url.trim();
    navigate(`/website-review${v ? `?url=${encodeURIComponent(v)}` : ""}#review`);
  };

  return (
    <div data-testid="audit-bar" className="relative z-20 w-full max-w-3xl mx-auto">
      <form
        onSubmit={submit}
        className="rounded-2xl sm:rounded-full glass border border-white/10 p-2 flex flex-col sm:flex-row items-stretch sm:items-center gap-2 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.8)]"
      >
        <label htmlFor="audit-url" className="hidden md:flex items-center gap-2 pl-4 pr-1 text-[13px] text-zinc-300 whitespace-nowrap">
          <MagnifyingGlass size={15} weight="bold" className="text-brand-400" />
          Already have a site?
        </label>
        <input
          id="audit-url"
          type="text"
          inputMode="url"
          autoComplete="url"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="yourwebsite.com"
          data-testid="audit-url-input"
          className="flex-1 min-w-0 bg-transparent px-4 py-3 text-[15px] text-white placeholder-zinc-500 focus:outline-none"
        />
        <button
          type="submit"
          data-testid="audit-submit"
          className="group inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-brand-600 text-white font-medium hover:bg-brand-500 transition-colors whitespace-nowrap"
        >
          Free website review
          <ArrowRight size={15} weight="bold" className="transition-transform group-hover:translate-x-0.5" />
        </button>
      </form>
      <p data-testid="audit-caption" className="mt-3 text-center text-[12.5px] text-zinc-400">
        We look at it ourselves — on a phone and a desktop — and reply within one business day. Free, no obligation.
      </p>
    </div>
  );
}
